import { Box, HStack, SimpleGrid, Text } from "@chakra-ui/react";
import React from "react";
import useProductDetailPageAttrQuery from "../hooks/useProductDetailPageAttrQuery";
import { ProductFeatureHero } from "../styles";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
const Feature = () => {
  const { data: result } = useProductDetailPageAttrQuery();
  const { features } = result!.data.attributes;

  return (
    <Box>
      <ProductFeatureHero>
        <SimpleGrid
          columns={{ base: 1, md: 2, lg: features.length }}
          spacing={4}
          mb={20}
        >
          {features?.map((item, index) => (
            <Box key={index} bg={"white50"} p={10}>
              <ReactMarkdown children={item.content} />
            </Box>
          ))}
        </SimpleGrid>
      </ProductFeatureHero>
    </Box>
  );
};
export default Feature;
